module.exports = __webpack_public_path__ + "static/compliance-ampol-8a6e303b1fe4c73dccca08cc61b26724.png";